var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBio21Lochgrafik10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 269.3 512.2",
    style: {
      enableBackground: "new 0 0 269.3 512.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#83B3E2;}\n\t.st1{fill:#D0DE8E;}\n\t.st2{fill:#D03632;}\n\t.st3{fill:#F9DB00;}\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st5{fill:#1F54B0;}\n\t.st6{fill:#D1D1D1;}\n\t.st7{fill:#4C702B;}\n\t.st8{fill:none;stroke:#000000;stroke-width:0.57;stroke-linecap:round;}\n\t.st9{fill:#93B838;}\n\t.st10{fill:#B1CC40;}\n\t.st11{fill:#CAF741;}\n\t.st12{fill:#FEF7CE;}\n\t.st13{fill:#DAEDCF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wasser"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.6,407.2c-4.1,3.2-5.3,1.8-9.6,0c-7.1-3-10.9-2.6-15.4-2.3c-2.3,0.2-3.8-1.7-11.6-1.3 c-8.1,0.5-10.5,7.2-12.2,12.4c-3.6,11-7.3,11.6-10.7,11.5c-6.6-0.2-8.7,3.6-9.2,12.3c-0.4,6.8,4.4,5,3,10.8c-0.9,3.8-6,9-2.6,12.1 c4.7,4.4,6.4-0.6,11.6,0.4c4.2,0.8,8.9-0.1,12.8-0.4c3.3-0.2,4.9,0.7,9.4,0.4c4-0.3,7.2-0.5,9.2,1.6c2.6,2.9,1.5,6.8,0.7,11.8 s-0.5,10.3-4.9,11.6c-7.4,2.2-4.1-2.2-9.9-5.7c-6.8-4.2-9.8-5.4-14.3-6.4c-10.7-2.5-13.7,5.5-18,1.3c-3.6-3.4,3-5.7-1.4-9.8 c-5.9-5.5-6,2.5-8.8,2.9c-2.1,0.3-3.2-1-2.8-4.6c1.2-10.6,8.5-10.9,9.9-21.8c1.4-10.7-4.1-13.1-1.2-17.3c3.4-4.9,8.3,0.9,15.7-3.2 c6.4-3.5,5.6-11.9,5.4-17c-0.5-14.8,1.9-16.5,11.4-22.4c10.6-6.5,18.9-4.8,25-4.9c8.8-0.2,17.1-4.2,22.5-1c4.3,2.5,17.6-5.6,18,1.3 c0.2,3-5.3,3.5-10.7,9.3C205.3,396.3,204,404.6,200.6,407.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "99.8,209.2 100.8,10.8 97,10.8 96.1,209.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.7,511.8l-0.6-298.6h-3.8l0.6,298.6c0.4-0.5,1.2-0.6,1.7-0.2c0.1,0,0.1,0.1,0.2,0.2 c0.4,0.5,1.2,0.6,1.7,0.2C100.5,511.9,100.6,511.9,100.7,511.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "98.1,468.6 96.6,468.6 96.6,471.1 98.1,471.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.5,187.3c2.9,5.2-1.6,11.9-1.8,15.1c-0.2,4.3-0.6,15.2-8.5,13.1c-10.8-2.8-1.6-13.4-11.6-15.4 c-7.1-1.4-7.4,6.6-17.3,6.9c-7.6,0.3-7.5-5.9-9.8-10.6c-2.4-5-6.8-10.7-13.3-19.2c-6.6-8.7-9.5-13.5-10.3-21.1 c-0.9-9.6,5.4-12.3,9.3-17.9c3-4.4,5.5-15.4,4.4-26.5c-0.8-8.2,2-12.5,9.1-14c9.1-1.9,16.2,2.4,17.6,3.7c2,1.8,1.3,3.3,2.9,4.9 c1.4,1.4,3.2,2.3,5.6,8.7c3.9,10.6,2,21.8,3.1,26.1c1,4,3.2,7.8,6.4,19.1S208.5,181.9,211.5,187.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.8,464.1c2.2-0.3,8.3-0.8,10.9,0.7l7.3,4.4c2.1,1.2,4.4,1.8,6.8,1.8l15.1,0.1v-2.5l-15.1-0.1 c-1.9,0-3.8-0.6-5.5-1.5l-7.3-4.4c-3.7-2.2-11.6-1.2-12.5-1c-0.3,0.4-0.2,0.9,0.1,1.2c0,0,0,0,0,0C56.9,463.1,57,463.7,56.8,464.1z "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Abschlag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.1,396.8c-3,0-4.2,2.1-4.4,7.3c-0.3,7.3,0.6,9.9,4.1,9.9c3.7,0,4.2-2.6,4.4-9.4 C129.4,398.9,128.4,396.9,125.1,396.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.4,400.8c0-2.1,1.7-3.7,3.8-3.7s3.7,1.7,3.7,3.8c0,2.1-1.7,3.7-3.7,3.7C123,404.6,121.4,402.9,121.4,400.8 C121.4,400.8,121.4,400.8,121.4,400.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.4,438c-4.7-0.4-5.3,6.5-5.9,10.9c-0.7,5-2,12.7,2.8,13.4c5.8,0.8,5.9-5.8,6.6-12.5 C117.6,443.6,118.3,438.4,113.4,438"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M109.4,442c0-2.1,1.7-3.7,3.8-3.7c2.1,0,3.7,1.7,3.7,3.8c0,2.1-1.7,3.7-3.7,3.7 C111.1,445.7,109.4,444.1,109.4,442"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.4,458.5c0-2.1,1.7-3.7,3.8-3.7c2.1,0,3.7,1.7,3.7,3.8c0,2-1.7,3.7-3.7,3.7 C109.1,462.2,107.4,460.5,107.4,458.5C107.4,458.5,107.4,458.5,107.4,458.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M121.1,410c0-2.1,1.7-3.7,3.8-3.7c2.1,0,3.7,1.7,3.7,3.8c0,2-1.7,3.7-3.7,3.7 C122.8,413.8,121.1,412.1,121.1,410C121.1,410,121.1,410,121.1,410"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Weg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207,457c0,0-16.9,1.5-43.3,4c-6.8,0.7-13.6,0.9-20.4,0.6c-3.8-0.1-5.4-0.2-7.9,0.9c-0.2,0.1-0.4,0.3-0.6,0.4 l-8,7c-1.8,1.8-3.5,3.8-5.1,5.8c-4.4,5.5-9.8,12.2-15.3,13.2v12.8c-0.4-0.4-1-0.4-1.4,0c0,0,0,0,0,0c-0.5,0.4-1.1,0.4-1.6,0v-73h3 V486c4.3-1.2,9.2-7.4,12.9-12c1.6-2.2,3.5-4.3,5.4-6.2l8.1-7.1c0.4-0.3,0.8-0.6,1.3-0.9c1.5-0.7,3.2-1.1,4.8-1.2 c-1.4-2.2-2.1-4.8-1.8-7.4c0.5-5.5,0.4-20.5,0.4-20.7v-10l3,0.1v0.8v9.1c0,0.6,0.1,15.4-0.4,21c-0.4,2.7,0.7,5.5,2.9,7.1h0.2 c6.7,0.3,13.4,0,20-0.6c26.4-2.4,43.3-4,43.3-4c-0.3,0.5-0.3,1.2,0.1,1.6C207.2,456.1,207.3,456.6,207,457z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.8,502.3l0.1-41.7h-3l-0.1,41.7c0,0,1,0.7,1.7,0C92.8,502,93.4,502,93.8,502.3 C93.8,502.3,93.8,502.3,93.8,502.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 481.5,
    transform: "matrix(1.326415e-02 -0.9999 0.9999 1.326415e-02 -390.2448 579.4739)",
    className: "st6",
    width: 3,
    height: 11.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M198.1,6.3c-0.1,0-10.8,0-21.7,0.1c-2.4,0.1-4.8,0.3-7.1,0.7c-4.9,0.7-11.1,1.6-25.2,0.7c-1.3-0.1-4.3-0.3-5,0 c-0.3,1-0.3,2,0,3l-2.9,0.8c-0.1-0.3-0.8-3.3,0.4-5.4c1-1.8,3.6-1.7,7.8-1.4c13.8,0.9,19.7,0,24.5-0.7c2.5-0.4,5-0.7,7.5-0.7 c10.9-0.2,21.6-0.1,21.7-0.1c-0.4,0.4-0.4,1.1,0,1.5C198.8,5.4,198.1,6.3,198.1,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M223.1,14.2c-0.8,0-77.9-1.9-99.9-2.5s-88-0.5-88.7-0.5c-2.2-0.2-8.1-0.4-10.8,0.6c-1.5,0.5-2.9,1.2-4.3,2 c-1.5,0.8-3,1.5-4.6,2.1c-3.1,0.7-6.2,1.1-9.4,1c-0.7,0-1.2,0-1.3,0s0.6-1.1,0-1.6s0-1.4,0-1.4s6.2,0.2,9.7-0.8 c1.4-0.5,2.7-1.1,4-1.9c1.5-0.9,3.1-1.6,4.7-2.2c3.8-1.3,11.6-0.8,11.9-0.7c0.5,0,66.6-0.1,88.6,0.5s99.1,2.5,99.9,2.5 c-0.4,0.4-0.5,1.1-0.1,1.5c0,0,0.1,0.1,0.1,0.1c0.4,0.2,0.5,0.7,0.3,1.1C223.3,14,223.2,14.1,223.1,14.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "rough"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M122.8,18.5c-10.9,1.1-14.9,8.7-18.4,26.1c-3.2,15.8-1.4,33.6-1.4,40.9c0,6.8-0.4,27.4,0,40.8 c0.4,11.2,6.4,12.4,6.2,30.4c-0.1,11.6-3.9,15.6-4,22.4s2.5,10.6,2.7,17.1c0.9,32.6-1.3,49.2-1.8,58.6c-0.9,15.5,1.8,25.1-1.7,65.8 c-2.7,31.6,6.9,33.2,14.8,33.9c6.4,0.5,14.5-4,17.8-14.1s8.6-15.2,13.5-31.9s8-21.2,12-43.7c2.3-23.7,2.1-45.5,0-61 c-3-22.5-23-30.2-23.5-48.9c0.1-13,11.2-11.6,13.3-28.2c2-16-1.4-18.1-0.5-29.4c0.8-9.7,6.6-11.9,5.9-28 c-0.6-14.1-4.8-24-11.8-34.5C141,27.6,137.9,17,122.8,18.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M167.6,137.4c-5.9-0.8-8.1-7.9-8.3-12.5c-0.3-6.8,2-15.9,10.8-14.4c6.1,1.1,10.3,3.1,6.9,13.4 C175.1,129.7,177,138.6,167.6,137.4"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "uebergang"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M142.3,420.1l-1.3,1.3v8.8l1.3,1.3 M136,420.1l1.3,1.3v8.8l-1.3,1.4 M133,458.4l-0.1,1.8l-8.3,7.3h-1.8  M137,463.3l-1.8-0.1l-8.1,7.1l-0.1,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M93.4,207.7l1.5,1.5l6.2,0.1l1.5-1.5 M102.4,214.4l-1.5-1.5l-6.2-0.1l-1.5,1.5 M95.6,465.2l-1.5,1.5v6.2 l1.5,1.5 M89.2,474.4l1.5-1.5v-6.2l-1.5-1.5 M94.1,484.2l1.5,1.5h6.2l1.5-1.5 M103.3,490.8l-1.5-1.5h-6.2l-1.5,1.5"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "green_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M117.4,81.9c-0.7,6.7,0.8,23.2,0.7,31c-0.3,14.8-5,28.9-4.2,43s11.7,26.4,13,46.6c0.7,11.7-5,21.9-6.3,32.4 c-1.5,11.7-2.5,18.9-3.7,21.5c-0.5,1.1-1.4,2.2-1.4,3.5s1,1.8,1.2,3.7c0.3,3.5,0.8,15.3,0.7,34.8c0,21.1-3.4,40.5,5.7,42.4 c12.9,2.6,15.5-18.3,19-35.3s4.2-20.9,5.5-37.7c0.7-9.2-1.6-18.6,0.3-28.7c0.4-2.4-2.5-3.7-1.5-8.6c1.9-9.2,6.2-7.6,6.7-22.8 c0.7-20.1-20.1-30.8-21-55.5c0.5-11.3,7.3-19.1,8.4-32.8c0.4-10.8-2.6-16.1-5.5-21.6c-2.1-4-4.2-7-5.6-16"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "green_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M118.3,47.5c-1.1-5-0.4-9.8,2.9-11.7c5.3-3,9-0.7,12.6,2.4c2.1,1.9,5.1,3.6,5.8,6.6c1.1,5-3.6,9.6-5.4,14.1 c-1,2.4-1.2,4.4-2.6,6.4c-2.2,3.2-3,2.7-3.2,6c-0.5,8.3,5.5,17.5-6.3,17.5c-8.8,0-1.8-12.3-5.4-20.7c-2-4.7-1.7-8.5-0.3-10.3 C119.9,53.1,119.3,51.9,118.3,47.5"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Put_area"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M122,37.4c3.2-3.2,6.9-1.8,10.6,1.2c2.4,2,5.5,4.4,5.4,7.7c-0.1,3-1.4,3.2-5.6,12.1c-1.6,3.6-2,6.8-4.8,8.4 c-2.6,1.7-6.1,1.4-8.4-0.7c-5.7-5.1,1.5-9.8,1.4-14S117.3,42.1,122,37.4"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Bunker"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M114.9,252.5c-2.7-2-6.4-1-6.8,2.9c-0.3,2.5,0.6,4.1,0.9,5.4c0.4,1.5-0.2,3-0.2,4.9s1.7,2.3,3,2.3 c2.2-0.1,4-1.8,4.3-4c0.1-2.2-1-2.7-1-4.1C115.2,257.7,118.9,255.2,114.9,252.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M150.5,245.2c-4.2-1.2-2.8-3.1-2.7-6.5c0.1-2.4-2.1-3.4-1.5-8c0.3-2.3,2-5.7,5.5-4.8c6.2,1.6,0,8.3,2.2,12.5 C154.8,239.9,154.8,246.5,150.5,245.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M134.1,62.2c0.5-1.6,2.6-5.3,6.3-2.7c1.7,1.2,1.4,3.5,0.6,4.8c-0.7,1-1.6,1.9-2.6,2.6c-1.2,1-0.1,2.3-2.2,4.9 c-1.3,1.6-4.6,2.3-6,0.5c-2.5-3.4,2.1-5,2.9-6.2C134,64.6,133.7,63.7,134.1,62.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M140.8,36.7c0.3,1.7-0.8,3.4-2.5,3.7c-0.1,0-0.2,0-0.4,0.1c-2.2-0.1-2.1-1.3-4.5-3c-1.5-1-3.8-2.8-1.8-6.3 c0.6-1.1,1.9-2.9,3.5-1.9c1.1,0.6,0.8,3.1,1.9,4.3S140.7,34.9,140.8,36.7"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "B\\xE4ume"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.3,426.6c-1.2,1.1-1.3,3-0.1,4.2c0.6,0.6,1.4,1,2.2,0.9c1.4,0,2.6-0.9,2.9-2.2c0.1,0,0.1,0,0.2,0 c1.7,0,3.1-1.3,3.1-3c0-1.7-1.3-3.1-3-3.1c-0.2,0-0.4,0-0.6,0.1c-0.3-1.6-1.9-2.7-3.5-2.3c-1.6,0.3-2.7,1.9-2.3,3.5 C97.4,425.5,97.8,426.1,98.3,426.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M157.1,119.2c0,1.5,1.2,2.8,2.7,2.9c-0.1,0.3-0.2,0.7-0.2,1c0,1.6,1.3,2.9,2.9,2.9c1.1,0,2.1-0.6,2.6-1.6 c0.5,0.3,1.1,0.5,1.6,0.5c0.2,0,0.3,0,0.5,0c0.5,0.6,1.3,1,2.2,1c1.6,0,2.9-1.3,2.9-3c0,0,0,0,0,0c0-0.2,0-0.5-0.1-0.7 c1.5,0.5,3.2-0.2,3.7-1.7c0.1-0.3,0.2-0.7,0.2-1.1c0-0.5-0.1-0.9-0.3-1.3c1.5-0.5,2.4-2.1,1.9-3.7c-0.3-0.9-1-1.6-1.9-1.9 c0.1-0.3,0.2-0.7,0.2-1c0.1-1.6-1.1-3-2.8-3.1s-3,1.1-3.1,2.8c0,0.1,0,0.2,0,0.3c0,0.4,0.1,0.8,0.2,1.2c-0.7,0.2-1.2,0.7-1.6,1.3 c-0.5-1.1-1.5-1.8-2.7-1.8l0,0c-0.1-0.3-0.3-0.6-0.6-0.9c0-0.2,0.1-0.4,0.1-0.6c0.1-1.6-1.1-3-2.8-3.1s-3,1.1-3.1,2.8 c0,0.1,0,0.2,0,0.3c0,0.3,0.1,0.7,0.2,1c-1.6,0.5-2.5,2.1-2.1,3.7c0.1,0.5,0.4,0.9,0.7,1.2C157.7,117.1,157.2,118.1,157.1,119.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M207.4,290.1c0-1.2-0.7-2.3-1.9-2.7c0.5-0.5,0.8-1.2,0.8-2c0-0.3-0.1-0.7-0.2-1c0.1,0,0.2,0,0.3,0 c1.6,0,2.9-1.3,2.9-2.9c0-1.6-1.3-2.9-2.9-2.9c-1.6,0-2.9,1.3-2.9,2.9c0,0,0,0,0,0c0,0.3,0.1,0.7,0.2,1c-0.1,0-0.2,0-0.3,0 c-1.6,0-2.9,1.3-2.9,2.9c0,1.2,0.8,2.3,1.9,2.7c-1.1,1.2-1,3,0.1,4.1s3,1,4.1-0.1C207.2,291.6,207.4,290.9,207.4,290.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M106.5,197c0.1-0.2,0.1-0.5,0.1-0.8c0-0.9-0.4-1.7-1.1-2.2c0.5-0.5,0.8-1.3,0.8-2c0-1.6-1.3-2.9-2.9-2.9 s-2.9,1.3-2.9,2.9c0,0.9,0.4,1.7,1.1,2.3c-0.5,0.5-0.8,1.3-0.8,2c0,0.3,0,0.5,0.1,0.8c-1.5,0.4-2.4,2-2,3.6 c0.4,1.2,1.5,2.1,2.8,2.1c0.7,0,1.5-0.3,2-0.8c1.1,1.1,3,1.1,4.1-0.1s1.1-3-0.1-4.1C107.4,197.4,106.9,197.1,106.5,197"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M105.8,232.3c0-1.5-1.1-2.7-2.6-2.9c0.2-0.4,0.4-0.9,0.4-1.4c0-0.5-0.1-1-0.4-1.4c1.4-0.7,2-2.4,1.4-3.9 c-0.4-0.8-1.1-1.3-1.9-1.5c0.8-1.4,0.4-3.1-1-4s-3.1-0.4-4,1c-0.3,0.5-0.4,1-0.4,1.5c0,0.7,0.3,1.5,0.8,2c-1.6,0.4-2.5,1.9-2.2,3.5 c0.2,1,1,1.8,2,2.1c-0.1,0.2-0.1,0.5-0.1,0.8c0,0.5,0.2,1.1,0.4,1.6c-1.4,0.7-2,2.5-1.2,3.9c0.4,0.7,1,1.2,1.8,1.5 c-0.3,0.5-0.5,1-0.5,1.6c0,1.6,1.3,2.9,2.9,2.9c1.6,0,2.9-1.3,2.9-2.9c0-0.5-0.1-1-0.4-1.5C104.9,234.8,105.8,233.6,105.8,232.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M165.4,131.7c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S165.4,130.1,165.4,131.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M174.4,137c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S174.4,135.3,174.4,137"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M93.6,4.8c0.1-2.6,2.2-4.6,4.7-4.5s4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.5-4.7,4.5C95.6,9.5,93.6,7.4,93.6,4.8 C93.6,4.8,93.6,4.8,93.6,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100.2,5.4c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C102.2,10,100.2,7.9,100.2,5.4C100.2,5.4,100.2,5.4,100.2,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M77.3,4.6C77.3,2,79.4,0,82,0c2.6,0,4.6,2.1,4.6,4.7s-2.1,4.6-4.7,4.6C79.3,9.2,77.3,7.2,77.3,4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M90.4,136c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.2,4.5-4.7,4.5 C92.4,140.7,90.4,138.6,90.4,136C90.4,136,90.4,136,90.4,136"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M91.1,126.5c0-2.6,2.2-4.6,4.7-4.5c2.6,0,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5 C93.1,131.1,91.1,129,91.1,126.5C91.1,126.5,91.1,126.5,91.1,126.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.3,115.3c0-2.6,2.2-4.6,4.7-4.5c2.6,0,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5 C99.3,119.9,97.3,117.8,97.3,115.3C97.3,115.3,97.3,115.3,97.3,115.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M90.8,107.1c0.1-2.6,2.2-4.6,4.7-4.5s4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.5-4.7,4.5 C92.8,111.8,90.8,109.7,90.8,107.1C90.8,107.1,90.8,107.1,90.8,107.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M89.9,97.4c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C91.9,102.1,89.8,100,89.9,97.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100,90.4c0-2.6,2.2-4.6,4.7-4.5c2.6,0,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5C102,95.1,100,93,100,90.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M90.7,84.7c0.1-2.6,2.2-4.6,4.7-4.5s4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.5-4.7,4.5C92.7,89.4,90.7,87.3,90.7,84.7 C90.7,84.7,90.7,84.7,90.7,84.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.9,76.6c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C100.9,81.2,98.8,79.1,98.9,76.6C98.9,76.6,98.9,76.6,98.9,76.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M90.1,73.9c0-2.6,2.2-4.6,4.7-4.5c2.6,0,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5 C92.1,78.6,90.1,76.5,90.1,73.9C90.1,73.9,90.1,73.9,90.1,73.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M84.3,17.2c0-2.6,2.2-4.6,4.7-4.5c2.6,0,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5 C86.3,21.9,84.2,19.7,84.3,17.2C84.3,17.2,84.3,17.2,84.3,17.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M117.2,16.4c0-2.5,2.1-4.6,4.6-4.5c2.5,0,4.6,2.1,4.5,4.6c0,2.5-2,4.5-4.5,4.5 C119.2,21,117.2,18.9,117.2,16.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M124.7,16.4c0-2.5,2.1-4.6,4.6-4.5c2.5,0,4.6,2.1,4.5,4.6c0,2.5-2,4.5-4.5,4.5C126.7,21,124.7,19,124.7,16.4 C124.7,16.4,124.7,16.4,124.7,16.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M89.4,188.3c0.1-2.6,2.2-4.6,4.7-4.5s4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C91.4,193,89.4,190.8,89.4,188.3C89.4,188.3,89.4,188.3,89.4,188.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M89.3,180c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C91.3,184.7,89.3,182.6,89.3,180"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M89.3,171c0.1-2.6,2.2-4.6,4.7-4.5s4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.5-4.7,4.5C91.3,175.7,89.2,173.6,89.3,171 C89.3,171,89.3,171,89.3,171"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.5,165.2c0.1-2.6,2.2-4.6,4.7-4.5s4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.5-4.7,4.5 C100.5,169.9,98.5,167.8,98.5,165.2C98.5,165.2,98.5,165.2,98.5,165.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.9,154c0-2.6,2.2-4.6,4.7-4.5c2.6,0,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5 C100.9,158.7,98.9,156.6,98.9,154C98.9,154,98.9,154,98.9,154"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.7,144.7c0.1-2.6,2.2-4.6,4.7-4.5s4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.5-4.7,4.5 C100.7,149.4,98.7,147.3,98.7,144.7C98.7,144.7,98.7,144.7,98.7,144.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M89.8,158.6c0-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5 C91.7,163.3,89.7,161.2,89.8,158.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M89.7,147.7c0-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5 C91.7,152.4,89.7,150.3,89.7,147.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M90.3,199.6c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C92.3,204.3,90.2,202.2,90.3,199.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M91.5,310c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C93.5,314.7,91.5,312.6,91.5,310"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M101.9,300.4c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C103.9,305.1,101.9,303,101.9,300.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M96.1,301.9c0.1-2.6,2.2-4.6,4.7-4.5s4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.5-4.7,4.5 C98.1,306.6,96,304.5,96.1,301.9C96.1,301.9,96.1,301.9,96.1,301.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M91,294.3c0-2.6,2.2-4.6,4.7-4.5c2.6,0,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5C93,299,91,296.9,91,294.3 C91,294.3,91,294.3,91,294.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M91.3,283.6c0-2.6,2.2-4.6,4.7-4.5c2.6,0,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5 C93.3,288.3,91.3,286.2,91.3,283.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M91.3,273.4c-0.1-2.6,1.9-4.7,4.4-4.8c2.6-0.1,4.7,1.9,4.8,4.4c0.1,2.6-1.9,4.7-4.4,4.8c-0.1,0-0.2,0-0.3,0 C93.4,277.8,91.3,275.9,91.3,273.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M91,260.6c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C93,265.3,91,263.2,91,260.6C91,260.7,91,260.7,91,260.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M89.5,250.5c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.2,4.6-4.7,4.5 C91.4,255.1,89.4,253,89.5,250.5C89.4,250.5,89.4,250.5,89.5,250.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M87.1,236.5c0-2.6,2.2-4.6,4.7-4.5c2.6,0,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5 C89.1,241.2,87.1,239.1,87.1,236.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M89.2,228.9c0-2.6,2.2-4.6,4.7-4.5c2.6,0,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5 C91.2,233.5,89.2,231.4,89.2,228.9C89.2,228.9,89.2,228.9,89.2,228.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100.4,207.8c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C102.4,212.5,100.4,210.4,100.4,207.8C100.4,207.8,100.4,207.8,100.4,207.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M101.3,222c0.1-2.6,2.2-4.6,4.7-4.5s4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.5-4.7,4.5 C103.3,226.7,101.3,224.6,101.3,222C101.3,222,101.3,222,101.3,222"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M86.8,316.3c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C88.8,321,86.8,318.8,86.8,316.3C86.8,316.3,86.8,316.3,86.8,316.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M86.7,327.9c0-2.6,2.2-4.6,4.7-4.5c2.6,0,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5 C88.7,332.6,86.6,330.5,86.7,327.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M89.9,339.8c0-2.6,2.2-4.6,4.7-4.5c2.6,0,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5 C91.9,344.5,89.8,342.3,89.9,339.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M89.9,351.2c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.2,4.5-4.7,4.5 C91.9,356,89.9,353.8,89.9,351.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M90.4,364.4c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C92.4,369.1,90.4,367,90.4,364.4C90.4,364.4,90.4,364.4,90.4,364.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M90.6,374.8c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C92.6,379.5,90.6,377.4,90.6,374.8C90.6,374.8,90.6,374.8,90.6,374.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M95.9,385c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C97.9,389.7,95.9,387.6,95.9,385C95.9,385,95.9,385,95.9,385"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M91.6,402.5c0-2.6,2.2-4.6,4.7-4.5c2.6,0,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5 C93.6,407.2,91.5,405.1,91.6,402.5C91.5,402.5,91.5,402.5,91.6,402.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M106.2,490.7c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C108.2,495.4,106.2,493.3,106.2,490.7C106.2,490.7,106.2,490.7,106.2,490.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M106,477.6c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C108,482.3,106,480.2,106,477.6C106,477.6,106,477.6,106,477.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.1,478.6c0-2.6,2.2-4.6,4.7-4.5c2.6,0,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5 C100.1,483.3,98.1,481.1,98.1,478.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M90.2,457.9c0.1-2.6,2.2-4.6,4.7-4.5s4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.5-4.7,4.5 C92.2,462.5,90.2,460.4,90.2,457.9C90.2,457.9,90.2,457.9,90.2,457.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M92.5,450.9c0-2.6,2.2-4.6,4.7-4.5c2.6,0,4.6,2.2,4.5,4.7c0,2.5-2.1,4.6-4.7,4.5 C94.5,455.6,92.5,453.5,92.5,450.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M92.1,433.2c0.1-2.6,2.2-4.6,4.7-4.5c2.6,0.1,4.6,2.2,4.5,4.7c-0.1,2.5-2.1,4.6-4.7,4.5 C94.1,437.9,92,435.8,92.1,433.2C92.1,433.2,92.1,433.2,92.1,433.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M164.5,240.4c0-2.5,2.1-4.5,4.6-4.4c2.5,0,4.5,2.1,4.4,4.6c0,2.5-2,4.4-4.5,4.4 C166.5,245,164.5,243,164.5,240.4C164.5,240.5,164.5,240.5,164.5,240.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M153.6,291.6c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5C155.6,296.1,153.6,294.1,153.6,291.6 C153.6,291.6,153.6,291.6,153.6,291.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M158.7,283.4c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5C160.7,287.9,158.7,285.9,158.7,283.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M167.4,278.7c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C169.4,283.2,167.3,281.2,167.4,278.7C167.3,278.7,167.3,278.7,167.4,278.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M174.1,277.4c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5C176.1,281.9,174.1,279.8,174.1,277.4 C174.1,277.4,174.1,277.4,174.1,277.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M167.4,284.9c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C169.4,289.5,167.3,287.4,167.4,284.9C167.3,284.9,167.3,284.9,167.4,284.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M160.9,274.8c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5C162.9,279.4,160.8,277.3,160.9,274.8 C160.9,274.8,160.9,274.8,160.9,274.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M169.6,270.2c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C171.6,274.7,169.6,272.7,169.6,270.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M170.1,259.1c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C172.2,263.6,170.1,261.6,170.1,259.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M176.5,263.3c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5C178.6,267.9,176.5,265.9,176.5,263.3 C176.5,263.4,176.5,263.3,176.5,263.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M161.6,266.1c0-2.5,2.1-4.5,4.5-4.5s4.5,2.1,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C163.6,270.7,161.6,268.6,161.6,266.1C161.6,266.1,161.6,266.1,161.6,266.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M161.7,258.8c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C163.7,263.3,161.7,261.3,161.7,258.8C161.7,258.8,161.7,258.8,161.7,258.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M140.5,327.6c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C143,331.9,140.8,330.1,140.5,327.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M146.4,321.2c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C148.9,325.5,146.6,323.7,146.4,321.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M154,326.1c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C156.5,330.4,154.3,328.6,154,326.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M154,317c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C156.5,321.3,154.3,319.5,154,317"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M153.3,308.3c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C155.8,312.6,153.6,310.8,153.3,308.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M162.1,310.2c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C164.6,314.5,162.4,312.7,162.1,310.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M159.7,301.3c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C162.2,305.6,160,303.8,159.7,301.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M162.3,292.8c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C164.8,297.1,162.6,295.3,162.3,292.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M149.3,312.5c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C151.8,316.7,149.6,315,149.3,312.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M150.8,299.1c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C152.8,303.7,150.8,301.6,150.8,299.1C150.8,299.1,150.8,299.1,150.8,299.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M164.9,214.1c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5C166.9,218.6,164.9,216.6,164.9,214.1 C164.9,214.1,164.9,214.1,164.9,214.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M178.6,221.4c0-2.5,2.1-4.5,4.5-4.5s4.5,2.1,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C180.6,225.9,178.6,223.9,178.6,221.4C178.6,221.4,178.6,221.4,178.6,221.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M173.6,215.9c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C175.6,220.4,173.6,218.4,173.6,215.9C173.6,215.9,173.6,215.9,173.6,215.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M166.7,223c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5C168.7,227.5,166.7,225.5,166.7,223 L166.7,223"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M166.1,232.4c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5C168.1,236.9,166.1,234.9,166.1,232.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M174.2,250.3c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C176.3,254.9,174.2,252.8,174.2,250.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M174,240.1c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5C176,244.6,174,242.6,174,240.1 C174,240.1,174,240.1,174,240.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M182,247c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5C184,251.5,182,249.5,182,247"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M174.3,229.4c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C176.3,233.9,174.3,231.9,174.3,229.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M181.1,236.8c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C183.1,241.3,181.1,239.2,181.1,236.8L181.1,236.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M183.5,227.9c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C185.5,232.5,183.5,230.4,183.5,227.9C183.5,227.9,183.5,227.9,183.5,227.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M183.3,213.9c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C185.3,218.5,183.3,216.4,183.3,213.9L183.3,213.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M165,249.4c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5C167,254,165,251.9,165,249.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M126.4,419.7c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C129,424,126.7,422.2,126.4,419.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M132.5,391.5c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C135,395.7,132.7,393.9,132.5,391.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M147,364.2c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C149.5,368.5,147.3,366.7,147,364.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M131.6,368.4c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C134.1,372.7,131.9,370.9,131.6,368.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M138.9,364.8c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C141.4,369.1,139.1,367.3,138.9,364.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M140.3,356.4c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C142.9,360.7,140.6,358.9,140.3,356.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M133.1,353c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C135.6,357.3,133.4,355.5,133.1,353"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M131.9,360.1c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C134.5,364.4,132.2,362.6,131.9,360.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M136.4,345.5c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C138.9,349.8,136.7,348,136.4,345.5C136.4,345.5,136.4,345.5,136.4,345.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M148,346.8c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C150.5,351,148.3,349.3,148,346.8C148,346.8,148,346.8,148,346.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M143.2,339.2c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C145.7,343.5,143.4,341.7,143.2,339.2C143.2,339.2,143.2,339.2,143.2,339.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M151,334.9c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C153.5,339.1,151.3,337.3,151,334.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M145.6,330.7c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C148.1,335,145.9,333.2,145.6,330.7C145.6,330.7,145.6,330.7,145.6,330.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M138.1,336.7c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C140.6,341,138.4,339.2,138.1,336.7C138.1,336.7,138.1,336.7,138.1,336.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M160.4,197.2c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C162.4,201.8,160.4,199.8,160.4,197.2C160.4,197.3,160.4,197.2,160.4,197.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M160.7,206.2c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C162.7,210.7,160.7,208.7,160.7,206.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M178,207c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5C180,211.5,178,209.5,178,207 C178,207,178,207,178,207"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M157.2,125.9c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C159.2,130.4,157.2,128.4,157.2,125.9C157.2,125.9,157.2,125.9,157.2,125.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M169.4,132.7c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C171.4,137.2,169.4,135.2,169.4,132.7C169.4,132.7,169.4,132.7,169.4,132.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M171.5,125.1c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5C173.5,129.6,171.5,127.6,171.5,125.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M164.6,111.3c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 C166.6,115.9,164.5,113.8,164.6,111.3C164.6,111.3,164.6,111.3,164.6,111.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M155,71.4c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9C157.5,75.7,155.3,73.9,155,71.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M157.1,64.8c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9C159.6,69.1,157.3,67.3,157.1,64.8 C157.1,64.8,157.1,64.8,157.1,64.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M156.1,58.9c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9C158.6,63.2,156.3,61.4,156.1,58.9 C156.1,58.9,156.1,58.9,156.1,58.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M150.1,100.8c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C152.6,105.1,150.4,103.3,150.1,100.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M168.1,98.3c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9C170.6,102.6,168.4,100.8,168.1,98.3 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M160.8,97.4c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9C163.3,101.6,161.1,99.9,160.8,97.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M155.9,90.2c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9C158.4,94.5,156.2,92.7,155.9,90.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M156.9,84.5c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9C159.4,88.8,157.1,87,156.9,84.5 C156.9,84.5,156.9,84.5,156.9,84.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M143.3,30.8c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C145.8,35,143.6,33.2,143.3,30.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M147.5,38.7c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9C150,42.9,147.8,41.2,147.5,38.7 C147.5,38.7,147.5,38.7,147.5,38.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M138,26.1c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C140.5,30.4,138.3,28.6,138,26.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M145.6,21.6c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C148.1,25.9,145.9,24.1,145.6,21.6C145.6,21.6,145.6,21.6,145.6,21.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M137.9,17.1c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9C140.4,21.4,138.2,19.6,137.9,17.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M144.5,15.2c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9C147,19.5,144.7,17.7,144.5,15.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M75.2,17c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9C77.7,21.3,75.5,19.5,75.2,17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M68.4,19c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9C71,23.3,68.7,21.5,68.4,19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M61.4,12.5c-0.3-2.5,1.5-4.7,4-4.9c2.5-0.3,4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9C64,16.7,61.7,15,61.4,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M135.8,150c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9C138.4,154.3,136.1,152.5,135.8,150 C135.8,150,135.8,150,135.8,150"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M137.7,145.5c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9C140.2,149.7,138,148,137.7,145.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M146.5,132.6c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C149.1,136.9,146.8,135.1,146.5,132.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M138.1,166.3c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C140.6,170.6,138.4,168.8,138.1,166.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M147.9,180.9c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C150.4,185.2,148.1,183.4,147.9,180.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M154.4,187.9c-0.3-2.5,1.5-4.7,4-4.9s4.7,1.5,4.9,4c0.3,2.5-1.5,4.7-4,4.9 C156.9,192.2,154.7,190.4,154.4,187.9C154.4,187.9,154.4,187.9,154.4,187.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M104.5,467.8c0,2-1.7,3.6-3.6,3.6c-2,0-3.6-1.7-3.6-3.6c0-2,1.6-3.6,3.6-3.6 C102.9,464.2,104.5,465.8,104.5,467.8C104.5,467.8,104.5,467.8,104.5,467.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M119.4,464.1c0,2-1.7,3.6-3.6,3.6c-2,0-3.6-1.7-3.6-3.6c0-2,1.6-3.6,3.6-3.6 C117.8,460.5,119.4,462.1,119.4,464.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M122.4,454.9c0,2-1.7,3.6-3.6,3.6c-2,0-3.6-1.7-3.6-3.6c0-2,1.6-3.6,3.6-3.6 C120.7,451.3,122.4,452.9,122.4,454.9C122.4,454.9,122.4,454.9,122.4,454.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M138.6,454.5c0,2-1.7,3.6-3.6,3.6s-3.6-1.7-3.6-3.6c0-2,1.6-3.6,3.6-3.6C137,450.8,138.6,452.5,138.6,454.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M107.9,252.9c0,2-1.7,3.6-3.6,3.6c-2,0-3.6-1.7-3.6-3.6c0-2,1.6-3.6,3.6-3.6 C106.3,249.3,107.9,250.9,107.9,252.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M109.2,238c0,2-1.7,3.6-3.6,3.6c-2,0-3.6-1.7-3.6-3.6c0-2,1.6-3.6,3.6-3.6C107.6,234.4,109.2,236,109.2,238"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBio21Lochgrafik10);
export default __webpack_public_path__ + "static/media/BIO21_lochgrafik_10.3f4d43f8f21a240f4124b03d4a5bb42a.svg";
export { ForwardRef as ReactComponent };